import loadable from '@loadable/component';

// 懒加载组件
const InvoiceManagement = loadable(() => import('./invoiceManagement2308/InvoiceManagement'));

export const subRoutes = [
  {
    path: '/InvoiceManagement',
    component: InvoiceManagement
  }
];
